export * from './utils'

/**
 * Colore grigio chiaro da usare quando DR è 0 (nullo).
 * Corrisponde alla CSS variable --nullo-color.
 */
export const DR_NULLO_COLOR = '#c8c8c8'
export const DR_NULLO_HEX = 'c8c8c8'
export const DR_NULLO_LABEL = 'nullo'

/**
 * Verifica se il valore DR è nullo (0 o assente).
 */
export function isDrNullo(drValue) {
  if (drValue == null) return true
  const num = typeof drValue === 'number' ? drValue : parseFloat(drValue)
  return isNaN(num) || num === 0
}

function normalizeHexColor(color) {
  if (color == null) return null

  const value = String(color).trim()
  if (!value) return null

  const normalized = value.startsWith('#') ? value : `#${value}`
  return /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(normalized) ? normalized : null
}

function indexEntries(indexMap) {
  if (Array.isArray(indexMap)) return indexMap
  if (indexMap && typeof indexMap === 'object') return Object.values(indexMap)
  return []
}

function worstIaColor(iaEntries) {
  let worstIa = null

  indexEntries(iaEntries).forEach(ia => {
    const value = typeof ia?.value === 'number' ? ia.value : parseFloat(ia?.value)
    const color = normalizeHexColor(ia?.color)

    if (!Number.isFinite(value) || !color) return

    if (worstIa === null || value > worstIa.value) {
      worstIa = { value, color }
    }
  })

  return worstIa?.color ?? null
}

/**
 * Colore dell'entry con valore peggiore (più alto) in una mappa/array di indici
 * ({ value, color }). Ritorna null se nessuna entry ha valore e colore validi.
 * Funziona sia per IA sia per IFR.
 */
export function getWorstIndexColor(entries) {
  return worstIaColor(entries)
}

export function getPunctualMonitoringColor(monitoring, fallbackColor = DR_NULLO_COLOR) {
  const directColor = normalizeHexColor(monitoring?.color)
  if (directColor) return directColor

  const directIaColor = worstIaColor(monitoring?.ia)
  if (directIaColor) return directIaColor

  const specificElementIaEntries = indexEntries(monitoring?.specificElements).reduce((entries, specificElement) => {
    return entries.concat(indexEntries(specificElement?.ia))
  }, [])
  const specificElementIaColor = worstIaColor(specificElementIaEntries)

  return specificElementIaColor ?? normalizeHexColor(fallbackColor) ?? fallbackColor
}

/**
 * Controlla se tutte le partizioni di un monitoraggio hanno DR pari a 0.
 * Accetta un array di specificElements ognuno con una proprietà `dr`
 * (oggetto con `sum`, oppure array con oggetti `sum`).
 */
export function isMonitoringDrNullo(specificElements) {
  if (!Array.isArray(specificElements) || specificElements.length === 0) return false
  return specificElements.every(el => {
    const drSum = el?.dr?.sum ?? el?.sum ?? (Array.isArray(el?.dr) ? el.dr[0]?.sum : undefined)
    return isDrNullo(drSum)
  })
}
